'use client'

import React, { ReactNode, useCallback, useMemo, useRef } from 'react'

import { AppContext } from 'Services/AppContext'

import GlobalStyles from 'Theme/GlobalStyles'

import { ApolloClientProvider } from './apolloClientProvider'
import { StoreProvider } from './storeProvider'
import StyleSheetProvider from './StyleSheetProvider'
import ThemeProvider from './ThemeProvider'

declare global {
  interface Window {
    WorklairWidget?: { open: () => void; close: () => void }
  }
}

type Props = { children: ReactNode }

export default function ClientAppProviders({ children }: Props) {
  const isSupportWidgetVisible = useRef(false)

  const handleToggleSupportWidgetVisibility = useCallback(() => {
    isSupportWidgetVisible.current = !isSupportWidgetVisible.current
    if (typeof window !== 'undefined' && window.WorklairWidget) {
      if (isSupportWidgetVisible.current) {
        window.WorklairWidget.open()
      } else {
        window.WorklairWidget.close()
      }
    }
  }, [])

  const ctxValue = useMemo(
    () => ({
      me: {}, // fill with real user later
      toggleSupportWidgetVisibility: handleToggleSupportWidgetVisibility,
    }),
    [handleToggleSupportWidgetVisibility],
  )

  return (
    <StoreProvider>
      <AppContext.Provider value={ctxValue}>
        <ApolloClientProvider>
          <StyleSheetProvider>
            <ThemeProvider>
              <GlobalStyles />

              {children}
            </ThemeProvider>
          </StyleSheetProvider>
        </ApolloClientProvider>
      </AppContext.Provider>
    </StoreProvider>
  )
}
